class VimeoHero {
  constructor() {
    this.vimeoSettings = '?background=1&muted=1&controls=0&autoplay=1&loop=1&title=0"';
    this.mobileSrcAttr = 'data-video-mobile';
    this.desktopSrcAttr = 'data-video-desktop';
    this.storedVimeoElements = [];
    this.initializeIframes();
    this.debounce = this.debounce.bind(this);
  }

  updateIframeSrc(iframe, mobileSrc, desktopSrc) {
    iframe.src = window.innerWidth <= 750 ? mobileSrc : desktopSrc;
  }

  debounce(func, wait) {
    let timeout;
    return function (...args) {
      const later = () => {
        clearTimeout(timeout);
        func.apply(this, args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }

  resetVimeoIframe() {
    const vimeoElements = document.querySelectorAll('.vimeohero');
    vimeoElements.forEach((element, index) => {
      const iframe = element.querySelector('iframe');
      if (iframe) {
        element.removeChild(iframe);
      }
    });

    this.initializeIframes();
  }

  initializeIframes() {
    const vimeoElements = document.querySelectorAll('.vimeohero');
    vimeoElements.forEach((element, index) => {
      const mobileSrc = element.getAttribute(this.mobileSrcAttr) + this.vimeoSettings;
      const desktopSrc = element.getAttribute(this.desktopSrcAttr) + this.vimeoSettings;
      const iframe = document.createElement('iframe');

      iframe.frameBorder = '0';
      iframe.allow = 'autoplay; fullscreen';

      this.updateIframeSrc(iframe, mobileSrc, desktopSrc);
      this.storedVimeoElements.push(element);

      element.appendChild(iframe);

      window.addEventListener(
        'resize',
        this.debounce(() => {
          this.updateIframeSrc(iframe, mobileSrc, desktopSrc);
        }, 250),
      );
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  window.vimeoHero = new VimeoHero();
});
